import { VenammSellState } from "@/domains/venamm"

type customIcon = "spinner" | "completed" | "failed" | "onchain-action"

type VenammStep = {
  number: number
  title: string
  key: string
  className: string
  dataContent?: string
  customIcon?: customIcon
}

export const venammStepMap: Record<VenammSellState, Array<VenammStep>> = {
  idle: [],
  quoting: [],
  "quote-ready": [],
  "quote-failed": [],
  "checking-reset-required": [
    {
      number: 1,
      title: "Checking",
      key: "reset",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  "reset-required": [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-neutral step-primary",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  resetting: [
    {
      number: 1,
      title: "Resetting",
      key: "reset",
      className: "step step-neutral step-primary",
      customIcon: "onchain-action",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  "reset-failed": [
    { number: 1, title: "Reset", key: "reset", className: "step step-neutral step-error", customIcon: "failed" },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral" },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  "checking-approval": [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Checking",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  approving: [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approving",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "onchain-action",
    },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  "waiting-for-approval-confirmation": [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approving",
      key: "approve",
      className: "step step-neutral step-primary",
      customIcon: "spinner",
    },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  "approve-failed": [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    { number: 2, title: "Approve", key: "approve", className: "step step-neutral step-error", customIcon: "failed" },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral" },
  ],
  selling: [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approve",
      key: "approve",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 3,
      title: "Selling",
      key: "sell",
      className: "step step-primary",
      customIcon: "onchain-action",
    },
  ],
  "sell-failed": [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approve",
      key: "approve",
      className: "step step-primary step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Sell", key: "sell", className: "step step-neutral step-error", customIcon: "failed" },
  ],
  complete: [
    {
      number: 1,
      title: "Reset",
      key: "reset",
      className: "step step-success",
      customIcon: "completed",
    },
    {
      number: 2,
      title: "Approve",
      key: "approve",
      className: "step step-success",
      customIcon: "completed",
    },
    { number: 3, title: "Sold", key: "sell", className: "step step-success", customIcon: "completed" },
  ],
}
